import React, { Component } from 'react';
import { Container, Image, Modal, Button, Form, Dropdown, Row, Col, DropdownButton, Pagination, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { store } from 'react-notifications-component';
import NumberFormat from 'react-number-format';
import { Bounce } from 'react-activity';

import Backend from '../../../Backend';
import Connection from '../../../Calls';

import logoCuadrado from '../../../Images/LogoWirebitTransfer_Azul.png'


function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

class TransferModal extends Component {
  constructor(props){
    super(props)
    this.state = {
      wallets:[],
      intenalFee:0
    }
  }

  componentWillMount(){
    this.getWallets(1,100000,'')
  }

  getWallets(value_paginaActual, value_numeroFilas, valueSearch) {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.availableCoins_rt( localStorage.getItem('token'), response.payload.r01, localStorage.getItem('email'), response => {
        this.setState({coinArr:response.payload})
      })
      Backend.GetWallets(localStorage.getItem('email'), localStorage.getItem('token'), valueSearch, value_paginaActual, value_numeroFilas, response.payload.r01, response => {
        if (response.status.code === "0") {
          self.setState({
            wallets: response.payload
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
        self.setState({showload:false})
      });
    });
  }

  close(){
    this.setState({
      intenalFee:0,
      toWallet:''
    })
    this.props.handleClose()
  }
  calculateCrypto(){
    var calculoCrypto;
    if(this.state.selectedCurrency == 'usd'){
      var calculoCrypto = (((this.state.amountW) * (1- (this.props.planInfo.transfer_internal/100) )) / this.state.usdPrice).toFixed(8)
    } else{
      var calculoCrypto = ((this.state.amountW) * (1- (this.props.planInfo.transfer_internal/100) )).toFixed(8)
    }
    return calculoCrypto
  }

  calculateUSD(){
    var calculoUsd;
    if(this.state.selectedCurrency == 'usd'){
      var calculoUsd = ((this.state.amountW) * (1- (Number(this.props.planInfo.transfer_internal)/100))).toFixed(2)
    } else{
      var amountFee = (Number(this.props.planInfo.transfer_internal) == 0) ? this.state.amountW :((this.state.amountW) * (1- (Number(this.props.planInfo.transfer_internal)/100)))
      var calculoUsd = formatMoney(amountFee * this.state.usdPrice)
    }
    return calculoUsd
  }

  sendTransfer(){
    const self = this;
    self.setState({showload:true})

    if(this.state.fromWallet == '' || this.state.toWallet == '' || this.state.amountW == '' || this.state.amountW == undefined || this.state.passwordW==''||this.state.passwordW == undefined){

      store.addNotification({
        title: "Error!",
        message: 'Please fill out all requeired fields',
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({showload:false})

      return
    }
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    let whiskas = Connection.RThzHrsb(this.state.passwordW);
    let combination2 = Connection.RThzHrsb("XWBX203");
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination2, "XWBX203", "2", whiskas, callback => {

        var amountToSend=(self.state.selectedCurrency==='usd')?self.calculateCrypto():self.state.amountW

        Backend.InternalTransfer(localStorage.getItem('email'), localStorage.getItem('token'), callback.payload.r03, this.state.fromWallet.id_walelt, this.state.toWallet.id_wallet, this.state.cryptoSend, response.payload.r01, '-', response => {
          if (response.status.code === "0") {
            store.addNotification({
              title: "Success!",
              message: 'Transfer successful',
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({
              selectedCurrency:'',
              fromWallet:'',
              toWallet:'',
              toAccount:'',
              toAlias:'',
              passwordW:'',
              description:'',
              amountW:0,
            },()=>{
              this.close();
              this.props.refresher()
            })
          } else {
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
          }
          self.setState({showload:false})
        });
        })
    });
  }
  cryptoSend(value){
    var calculoCrypto;
    if(this.state.selectedCurrency == 'usd'){
      var calculoCrypto = ((value) / this.state.usdPrice).toFixed(8)
    } else{
      var calculoCrypto = value
    }
      this.setState({
        amountW: value,
        cryptoSend: calculoCrypto
      })
  }


  renderListWalletsTo() {
    const self = this;
    var wallets = [];
    if(self.state.fromWallet){
      self.state.wallets.forEach(function (item) {
        if(item.coin === self.state.fromWallet.coin)
        wallets.push(
          <Dropdown.Item onClick={()=>{self.setState({toWallet:item})}} as="button">
            <Image src={require("../../../CryptoIcons/" + item.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
            {item.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(item.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{item.coin}</label>
          </Dropdown.Item>
        );
      });
    }
    return wallets;
  }

  getPrice(wallet){
    let price
    this.state.coinArr.forEach((item, i) => {
      if(item.symbol == wallet.coin){
        price = item.usd_price
      }
    });
    return price
  }

  renderListWalletsFrom() {
    const self = this;
    var wallets = [];
    self.props.wallets.forEach(function (item) {
      wallets.push(
        <Dropdown.Item onClick={()=>{self.setState({fromWallet:item,usdPrice:self.getPrice(item), toWallet:''})}} as="button">
          <Image src={require("../../../CryptoIcons/" + item.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
          {item.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(item.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{item.coin}</label>
        </Dropdown.Item>
      );
    });
    return wallets;
  }


  render(){
    let intenalFee = (100-this.props?.planInfo?.transfer_internal)/100
    return(
      <Modal className={"modal-transfer-ecomm"} centered aria-labelledby="contained-modal-title-vcenter" show={this.props.show} onHide={() => { this.close() }}>

        <Modal.Body>
            <Row>
              <div className="container-steps-add-wallet-general">
                <div>
                <Row style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                  <Image src={logoCuadrado} style={{width:'20%'}}/>
                </Row>
                <Row style={{display:'flex', justifyContent:'center', alignItems:'center',marginTop:20}}>
                  <Col md={5} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">From Wallet:</Form.Label>
                    <Dropdown title={(this.state.fromWallet)?this.state.fromWallet.alias:'Select a wallet...'}>
                      <Dropdown.Toggle id="dropdown-custom-1">
                        {
                          (this.state.fromWallet)
                          ?
                          <>
                            <Image src={require("../../../CryptoIcons/" + this.state.fromWallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                            {this.state.fromWallet.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(this.state.fromWallet.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{this.state.fromWallet.coin}</label>
                          </>
                          :'Select a wallet...'
                        }
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {this.renderListWalletsFrom()}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  {/* <Col md={1}>
                    <center><Image src={flechitas} style={{width:'50%', marginTop:'1.5em'}}/></center>
                  </Col> */}
                  <Col md={5} className='virtual_exchange_dropdown'>
                    <Form.Label className="virtual_exchange_information_wallets_text">To Wallet:</Form.Label>
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-custom-1">
                        {
                          (this.state.toWallet)
                          ?
                          <>
                            <Image src={require("../../../CryptoIcons/" + this.state.toWallet.coin + ".svg")} style={{ width: 15, marginTop: -4, marginRight: 5 }} />
                            {this.state.toWallet.alias}: <label style={{ fontWeight: "bold", marginBottom: 0 }}>{Number(this.state.toWallet.balance).toFixed(8)} </label> <label style={{ textTransform: "uppercase", marginBottom: 0 }}>{this.state.toWallet.coin}</label>
                          </>
                          :'Select a wallet...'
                        }
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {this.renderListWalletsTo()}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                </Row>
                <Row style={{marginTop:20}}>
                  {
                    (this.state.fromWallet && this.props.planInfo)?
                    <Col sm={{span:8,offset:2}}>
                      <p className='text-available-modal'>Available: {this.state.fromWallet.balance} {this.state.fromWallet.coin}</p>
                      <Form.Group as={Row}>
                        <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">Amount</Form.Label>
                        <Col sm="10" className="virtual_exchange_dropdown">
                          <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                            {
                              (this.state.selectedCurrency == 'usd')
                              ? <NumberFormat className='btc-format-input' placeholder="USD Amount" decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                              : <NumberFormat className='btc-format-input' placeholder={this.state.fromWallet.coin.toUpperCase() + ' Amount'} decimalScale={8} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                            }
                            <Button className={(this.state.selectedCurrency === this.state.fromWallet.coin) ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: this.state.fromWallet.coin }) }}>{this.state.fromWallet.coin.toUpperCase()}</Button>
                            <Button className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                          </div>
                          <div className={(this.state.amountW) ? "container-addresses-label" : "container-addresses-label-error"}>
                            <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"} style={{marginBottom: 2}}>You will transfer {Number(this.calculateCrypto()* intenalFee).toFixed(8)} {this.state.fromWallet.coin} ({Number(this.props.planInfo.transfer_internal).toFixed(0)}% fee)</p>
                            <p className={!this.state.amountW ? "label-addresses-captured-success" : "label-addresses-captured-warning"}>Approximately {this.calculateUSD()} usd</p>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                    :
                    <Col sm={{span:8,offset:2}}>
                      <p className='text-available-modal'>Available: </p>
                      <Form.Group as={Row}>
                        <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">Amount</Form.Label>
                        <Col sm="10" className="virtual_exchange_dropdown">
                          <div className="input-signup" style={{ display: "flex", alignItems: "center" }}>
                            <NumberFormat disabled className='btc-format-input' placeholder="USD Amount" decimalScale={2} thousandSeparator={true} prefix={'$'} value={this.state.amountW} onValueChange={(values) => {const {formattedValue, value} = values; this.cryptoSend(value)}} />
                            <Button disabled variant="link" className={"boton-seleccionar-currency"}>-</Button>
                            <Button disabled className={(this.state.selectedCurrency === 'usd') ?"boton-seleccionar-currency-selected" :"boton-seleccionar-currency"} variant="link" onClick={() => { this.setState({ selectedCurrency: 'usd' }) }}>USD</Button>
                          </div>
                        </Col>
                      </Form.Group>

                    </Col>
                  }
                </Row>
                <Row>
                  <Col  sm={{span:8,offset:2}}>
                    <Form.Group as={Row} style={{display:'flex',alignItems:'center'}}>
                      <Form.Label column sm="2" className="virtual_exchange_information_wallets_text">Wallet Password</Form.Label>
                      <Col sm="10" className="virtual_exchange_dropdown">
                        <Form.Control type="password" placeholder="Password" value={this.state.passwordW} onChange={(passwordW) => { this.setState({ passwordW: passwordW.target.value }) }} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <div style={{ marginTop: 30, textAlign: "center" }}>
                  <Button onClick={() => { this.sendTransfer()}} className="signup-button" variant="primary" disabled={this.state.showLoad}>
                    {
                      (this.state.showload)
                        ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                        : "Send Transfer"
                    }
                  </Button>
                </div>
                </div>
              </div>
            </Row>

        </Modal.Body>
      </Modal>
    )
  }
}
export default TransferModal;
